"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    id: "Present",
    transform: "translate(1.000000, 0.500000)",
    fill: "currentColor",
    fillRule: "nonzero",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M21,2.5 L21,13.5 L21,14.5 C21,15.0522847 20.5522847,15.5 20,15.5 L11.75,15.5 L11.75,21 L14,21 C14.5522847,21 15,21.4477153 15,22 C15,22.5522847 14.5522847,23 14,23 L8,23 C7.44771525,23 7,22.5522847 7,22 C7,21.4477153 7.44771525,21 8,21 L10.25,21 L10.25,15.5 L2,15.5 C1.44771525,15.5 1,15.0522847 1,14.5 L1,13.5 L1,2.5 C0.44771525,2.5 6.76353751e-17,2.05228475 0,1.5 L0,1 C-6.76353751e-17,0.44771525 0.44771525,-1.67490378e-15 1,-1.77635684e-15 L21,-1.77635684e-15 C21.5522847,-1.8778099e-15 22,0.44771525 22,1 L22,1.5 C22,2.05228475 21.5522847,2.5 21,2.5 Z M19,2.5 L3,2.5 L3,13.5 L19,13.5 L19,2.5 Z M7,7 L15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L7,9 C6.44771525,9 6,8.55228475 6,8 C6,7.44771525 6.44771525,7 7,7 Z",
      id: "Combined-Shape"
    })
  })
}));